import type React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../skeleton/Card'
import { cn } from '../../lib/utils/cn'

interface StatsCardProps {
  title: string
  value: string | number
  description?: string
  icon?: React.ReactNode
  className?: string
  isLoading?: boolean
  isPreviousData?: boolean
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  description,
  icon,
  className,
  isLoading,
  isPreviousData,
}) => {
  return (
    <Card className={cn('shadow-lg', className)}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">
          {isLoading ? (
            <div className="h-4 w-24 bg-gray-200 dark:bg-slate-700 rounded animate-pulse" />
          ) : (
            title
          )}
        </CardTitle>
        {icon && (
          <div className={cn('w-4 h-4 text-muted-foreground', isLoading && 'invisible')}>
            {icon}
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">
          {isLoading ? (
            <div className="h-8 w-32 bg-gray-200 dark:bg-slate-700 rounded animate-pulse" />
          ) : (
            <span className={cn(isPreviousData && 'text-muted-foreground')}>{value}</span>
          )}
        </div>
        {description && (
          <p className="text-xs text-muted-foreground mt-2">
            {isLoading ? (
              <div className="h-3 w-40 bg-gray-200 dark:bg-slate-700 rounded animate-pulse" />
            ) : (
              description
            )}
          </p>
        )}
      </CardContent>
      {isPreviousData && !isLoading && (
        <div className="absolute top-2 right-2">
          <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200 rounded-full">
            Previous data
          </span>
        </div>
      )}
    </Card>
  )
}
